<template>
    <div class="ranking">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
            <div v-for="(v, k) in jobTabs" :key="k">
                <div v-if="currentJobTab == k + 1">
                    <!-- banner -->
                    <img class="banner" :src="`${v.url}2025-04-24/${v.bannerImg}.png`" alt="banner">
                    <span class="rule" @click="toRule"> 活动规则 </span>
                    <!-- 奖品 -->
                    <div class="reward-box">
                        <div class="reward" :style="{ backgroundImage: `url(${v.url}2025-04-24/${v.rewardImg}.png)` }">
                            <div class="horizantalBox">
                                <div class="reward-data">
                                    <div v-if="currentJobTab == 1">
                                        <div>水光类销售额达标</div>
                                        <div>积分数量第1名<span class="bonus-text">{{ firstPrize }}元</span>奖金</div>
                                        <div>积分数量第2名<span class="bonus-text">{{ secondPrize }}元</span>奖金</div>
                                    </div>
                                    <div v-if="currentJobTab == 2">
                                        <div>小组第一名，获得</div>
                                        <div class="fontRed">新品Colnt胶原网12毫克2瓶</div>
                                        <div class="mt-10">小组第二、三名，获得</div>
                                        <div class="fontRed">新品Colnt胶原网12毫克1瓶</div>
                                    </div>
                                    <div v-if="currentJobTab == 3">
                                        <div>小组PK率达成率第一名</div>
                                        <div class="fontRed">{{ pkFirstPrize }}元奖金</div>
                                        <template v-if="currentGroupTab !== '1'">
                                            <div class="mt-10">小组PK率达成率第二名</div>
                                            <div class="fontRed">{{ pkSecondPrize }}元奖金</div>
                                        </template>
                                    </div>
                                </div>
                                <div class="reward-data">
                                    <img :src="`${v.url}2025-04-24/${currentJobTab == 2 ? 'cargo' : currentJobTab == 3 && currentGroupTab === '1' ? '2000cash' : 'cash'}.png`" alt="left image">
                                </div>
                            </div>
                        </div>
                        <img v-if="(currentJobTab == 1 && !v.dataInfo.kdData) || (currentJobTab == 2 && !v.dataInfo.xpData) || (currentJobTab == 3 && !v.dataInfo.tjData)" class="reward-status" :src="`${v.url}2025-02-18/award-status1.png`">
                        <template v-else>
                            <img class="reward-status" :src="`${v.url}2025-02-18/${compareTime(v.dataInfo.dateTime, v.dataInfo.isReach)}`">
                        </template>
                        <template v-if="(currentJobTab == 1 && v.dataInfo.kdData) || (currentJobTab == 2 && v.dataInfo.xpData) || (currentJobTab == 3 && v.dataInfo.tjData)">
                            <div v-if="currentJobTab != 3" :class="{ lineBorder: currentJobTab == 1 }" class="mb-30">
                                <div class="font24">
                                    {{ currentJobTab == 1 ? '水光类销售额' : '当前新品销售额' }}
                                </div>
                                <div class="mt-30">
                                    <span class="font46 blue">{{ currentJobTab == 1 ? v.dataInfo.sgSaleAmt : v.dataInfo.xpSaleAmt || 0 }}w</span><span v-if="currentJobTab == 1" :class="{ blue: v.dataInfo.sgSaleRate >= 100, red: v.dataInfo.sgSaleRate < 100 }">({{ v.dataInfo.sgSaleRate || 0 }}%{{ v.dataInfo.sgSaleRate >= 100 ? '已' : '未' }}达标)</span>
                                </div>
                            </div>
                            <div class="compare" v-if="currentJobTab == 1">
                                <div class="compare-data">
                                    <p></p>
                                    <p>{{ v.leftText1 }}</p>
                                    <p class="blue">{{ v.dataInfo.mayPoints || 0 }}分</p>
                                </div>
                                <div class="less font46">+</div>
                                <div class="compare-data">
                                    <p></p>
                                    <p>{{ v.leftText2 }}</p>
                                    <p class="blue">{{ v.dataInfo.junePoints || 0 }}分</p>
                                </div>
                                <div class="less font46">=</div>
                                <div class="compare-data">
                                    <p></p>
                                    <p>{{ v.rightText1 }}</p>
                                    <p class="blue">{{ v.dataInfo.allPoints || 0 }}分</p>
                                </div>
                            </div>
                            <div class="compare" v-if="currentJobTab == 3">
                                <div class="compare-data">
                                    <p>{{ v.leftText1 }}</p>
                                    <p>{{ v.leftText2 }}</p>
                                    <p class="blue">{{ v.dataInfo.xpSaleAmt || 0 }}w<span class="font30" :class="{ blue: v.dataInfo.xpSaleRate >= 100, red: v.dataInfo.xpSaleRate < 100 }">({{ v.dataInfo.xpSaleRate || 0 }}%)</span></p>
                                </div>
                                <div class="compare-data">
                                    <p>{{ v.rightText1 }}</p>
                                    <p>{{ v.rightText2 }}</p>
                                    <p class="blue">{{ v.dataInfo.sgSaleAmt || 0 }}w<span class="font30" :class="{ blue: v.dataInfo.sgSaleRate >= 100, red: v.dataInfo.sgSaleRate < 100 }">({{ v.dataInfo.sgSaleRate || 0 }}%)</span></p>
                                </div>
                            </div>
                            <p class="update-time">{{ v.updateTime }}{{ formattedDate(v.dataInfo.dateTime) }}0点</p>
                        </template>
                    </div>

                    <div class="bg-color" :style="{ backgroundColor: v.bgColor }"></div>
                </div>
            </div>
            <div class="ranking-box">
                <div class="tabs-box">
                    <div class="job-tabs">
                        <div class="job-tab-item" v-for="it in jobTabs" :key="it.dictValue" :class="{ on: currentJobTab === it.dictValue }" @click="onJobTab(it)">
                            {{ it.dictLabel }}
                        </div>
                    </div>
                    <div class="group-tabs">
                        <div class="group-tab-item" :class="{ ['on' + currentJobTab]: currentGroupTab === it.dictValue }" v-for="(it, i) in groupTabs" :key="i" @click="onGroupTab(it)">
                            {{ it.dictLabel }}
                        </div>
                    </div>
                </div>
                <div class="ranking-list-box" v-for="(item, index) in jobTabs" :key="index">
                    <div v-if="currentJobTab == index + 1">
                        <div class="ranking-list-item-box" v-if="(currentJobTab == 1 && item.dataInfo.kdData) || (currentJobTab == 2 && item.dataInfo.xpData) || (currentJobTab == 3 && item.dataInfo.tjData)">
                            <RankingItem :status="currentJobTab" :item="currentJobTab == 1 ? item.dataInfo.kdData : currentJobTab == 2 ? item.dataInfo.xpData : item.dataInfo.tjData" isMe :style="{ backgroundColor: isMeBg }" />
                        </div>
                        <div class="ranking-list-item title">
                            <div class="ranking-num">排名</div>
                            <div class="ranking-name" :class="nameWidth">{{ item.title1 }}</div>
                            <div class="ranking-order" :class="orderWidth">{{ item.title2 }}</div>
                            <div class="ranking-bonus" v-if="currentJobTab != 2" :class="bonusWidth">{{ item.title3 }}</div>
                        </div>
                        <RankingItem :status="currentJobTab" :item="it" v-for="(it, i) in list" :key="i + 'listIndex'" />
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import RankingItem from './rankingItem.vue'
    import { debounce } from 'lodash';
    import { ActionSheet, Toast } from 'vant'

    export default {
        name: 'YMrankingList',
        components: {
            RankingItem,
            [ActionSheet.name]: ActionSheet
        },
        computed: {
            compareTime() {
                return function (time, award) {
                    const endTime = this.currentJobTab == 1 ? '2025-06-30 23:59:59' : '2025-05-31 23:59:59'
                    const isTimeout = new Date(time).getTime() > new Date(endTime).getTime()
                    // 超时未获奖
                    if (isTimeout && award == 0) {
                        return 'award-status4.png'
                    }
                    // 超时获奖
                    if (isTimeout && award != 0) {
                        return 'award-status5.png'
                    }
                    // 未超时未获奖
                    if (!isTimeout && award == 0) {
                        return 'award-status2.png'
                    }
                    // 未超时获奖
                    if (!isTimeout && award != 0) {
                        return 'award-status33.png'
                    }
                    return
                }
            },
            formattedDate() {
                return function (date) {
                    const useDate = new Date(date);
                    // useDate.setDate(useDate.getDate() - 1); // 减去一天
                    return useDate.toLocaleDateString('zh-CN', { month: 'long', day: 'numeric' });
                }
            },
            firstPrize() {
                switch (this.currentGroupTab) {
                    case "1": return 3000;
                    case "2": return 2000;
                    case "3": return 1500;
                    default: return 800;
                }
            },
            secondPrize() {
                switch (this.currentGroupTab) {
                    case "1": return 2500;
                    case "2": return 1500;
                    case "3": return 1000;
                    default: return 500;
                }
            },
            pkFirstPrize() {
                switch (this.currentGroupTab) {
                    case "1": return 2000;
                    case "2": return 1000;
                    default: return 500;
                }
            },
            pkSecondPrize() {
                switch (this.currentGroupTab) {
                    case "2": return 800;
                    default: return 300;
                }
            },
            isMeBg() {
                switch (this.currentJobTab) {
                    case "1": return "#F6F2FF";
                    case "2": return "#FDF4E4";
                    default: return "#F9F5F0 ";
                }
            },
            nameWidth() {
                return this.currentJobTab !== "3" ? 'width320' : 'width200';
            },
            orderWidth() {
                return this.currentJobTab === "1" ? 'width180' : this.currentJobTab == 2 ? 'width240' : 'width160';
            },
            bonusWidth() {
                return this.currentJobTab == 1 ? 'width100' : 'width200'
            }
        },
        data() {
            return {
                showRule: false, // 是否显示规则弹窗
                jobTabs: [], // 分类标签列表
                currentJobTab: '1', // ['客单积分PK', '新品PK', '团建基金']
                groupTabs: [], // 分组标签列表
                currentGroupTab: '1', // 当前选中的分组
                loading: false, // 是否正在加载
                finished: false, // 是否加载完成
                list: [], // 排名列表数据
                page: 1, // 当前页码
                error: false, // 是否发生错误
                themeArr: [
                    {
                        "bgColor": "#AF8BDF ",
                        "url": "https://staticwecom.beautyfarm.com.cn/wecom-workbench/",
                        "bannerImg": "banner1",
                        "rewardImg": "baseBg1",
                        "leftText1": "5月积分",
                        "leftText2": "6月积分",
                        "rightText1": "合计积分",
                        "rightText2": "",
                        "updateTime": "数据更新时间",
                        "title1": "姓名",
                        "title2": "水光类销售额",
                        "title3": "积分",
                        jobtab: '',
                        dataInfo: {}
                    },
                    {
                        "bgColor": "#E5EAEE ",
                        "url": "https://staticwecom.beautyfarm.com.cn/wecom-workbench/",
                        "bannerImg": "banner2",
                        "rewardImg": "baseBg2",
                        "leftText1": "",
                        "leftText2": "",
                        "rightText1": "",
                        "rightText2": "",
                        "updateTime": "数据更新时间",
                        "title1": "姓名",
                        "title2": "新品销售额",
                        "title3": "",
                        jobtab: '',
                        dataInfo: {}
                    },
                    {
                        "bgColor": "#EAE2DA",
                        "url": "https://staticwecom.beautyfarm.com.cn/wecom-workbench/",
                        "bannerImg": "banner3",
                        "rewardImg": "baseBg3",
                        "leftText1": "我的门诊",
                        "leftText2": "当前新品销售额",
                        "rightText1": "我的门诊",
                        "rightText2": "当前五款新品销售额",
                        "updateTime": "数据更新时间",
                        "title1": "门诊",
                        "title2": "水光销售额 ",
                        "title3": "五款新品销售额",
                        jobtab: '',
                        dataInfo: {}
                    }
                ],
            }
        },
        mounted() {
            this.getjobTabs()
        },
        methods: {
            // 初始化数据，获取销售列表
            getDataList: debounce(async function () {
                Toast.loading({
                    forbidClick: true,
                    duration: 0
                });
                if (this.finished) return
                try {
                    const params = {
                        groupNo: this.currentGroupTab,
                        type: this.currentJobTab,
                        page: this.page
                    }
                    const { code, msg, data } = await request({
                        url: '/motivate/getList',
                        method: 'get',
                        params
                    })
                    if (code !== 0) {
                        throw new Error(msg)
                    }
                    Toast.clear();
                    // 对应jobTabs中的dataInfo赋值
                    for (let i = 0; i < this.jobTabs.length; i++) {
                        if (this.jobTabs[i].dictValue === this.currentJobTab) {
                            this.jobTabs[i].dataInfo = data
                        }
                    }
                    // 积分pk取kdList 新品pk取xpList 团建基金取tjList
                    let list = []
                    if (data && data.kdList && data.kdList.length > 0 && this.currentJobTab == '1') {
                        list = data.kdList
                    } else if (data && data.xpList && data.xpList.length > 0 && this.currentJobTab == '2') {
                        list = data.xpList
                    } else if (data && data.tjList && data.tjList.length > 0 && this.currentJobTab == '3') {
                        list = data.tjList
                    }
                    if (this.page == 1) {
                        this.list = list
                    } else {
                        this.list = this.list.concat(list)
                    }
                    this.page += 1
                    this.loading = false;

                    if (list.length < 10) {
                        this.finished = true;
                    }
                } catch (error) {
                    this.loading = false;
                    this.error = true;
                    this.$toast(error)
                }

            }, 500),
            // 获取分组标签
            async getGroupTab() {
                const { data } = await request({
                    url: '/motivate/groupNo',
                    method: 'get',
                    params: { type: this.currentJobTab }
                })
                if (data && data.list && data.list.length > 0) {
                    this.groupTabs = data.list.map((item, index) => {
                        return { dictValue: item, dictLabel: `第${item}组` }
                    })
                } else {
                    this.groupTabs = []
                }
                // 默认选中 如果在groupTabs中没有匹配就取第一个
                this.currentGroupTab = this.groupTabs.find(item => item.dictValue === this.groupTab) || this.groupTabs[0].dictValue;
                this.getDataList()
            },
            onLoad() {
                this.getDataList()
            },
            // 获取职位分类标签
            async getjobTabs() {
                const { data } = await request({
                    url: '/dict/type/dictList',
                    method: 'get',
                    params: { dictType: 'ym_jlzx_list' }
                })
                // 重组数据，该处理应新建数据进去
                const newArr = data.map((item, index) => {
                    return { ...item, ...this.themeArr[index] }
                })
                this.jobTabs = newArr
                this.getGroupTab()
            },
            onJobTab(value) {
                this.currentJobTab = value.dictValue;
                this.page = 1
                this.finished = false
                this.error = false;
                this.getGroupTab()
            },
            // 切换分组标签
            onGroupTab(v) {
                console.log(v)
                if (this.currentGroupTab == v.dictValue) return
                this.currentGroupTab = v.dictValue;
                this.finished = false
                this.error = false;
                this.page = 1
                this.getDataList()

            },
            toRule() {
                this.$router.push({ path: '/YMrankingRules', query: { currentJobTab: this.currentJobTab } })
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking {
        position: relative;
        height: 100%;
        font-size: 28px;
        overflow-y: scroll;
        color: #333333;
        background-color: #fff;
    }

    .banner {
        width: 100%;
        height: 464px;
    }

    .rule {
        position: absolute;
        width: 120px;
        top: 50px;
        right: 0;
        width: 120px;
        height: 61px;
        line-height: 61px;
        font-size: 26px;
        text-align: center;
        color: #ffffff;
        background: rgba(0, 0, 0, 0.5);
        border-top-left-radius: 31px;
        border-bottom-left-radius: 31px;
        // padding: 10px 0;
    }

    .reward-box {
        position: relative;
        width: 100%;
        // height: 860px;
        margin-top: -94px;
        padding: 30px;
        text-align: center;
        background-color: #fff;
        border-radius: 40px;
        z-index: 9;

        .reward-status {
            width: 100%;
            margin-bottom: 30px;
        }
    }

    .reward {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        height: 349px;
        // padding-bottom: 30px;
        // padding-top: 80px;
        margin-bottom: 30px;
        // background-image: url('https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-04-24/bg.png');
        background-size: 100% 100%;

        // &.left {
        //     padding-right: 30px;
        //     padding-left: 20px;
        // }
        >div {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .horizantalBox {
            padding: 80px 38px 30px 38px;
        }

        .columnBox {
            align-items: flex-end;
        }

        .reward-data {
            flex-grow: 1;
            flex-shrink: 0;
            text-align: center;
            width: 30%;

            >img {
                height: 150px;
            }

            >div {
                font-size: 26px;
            }

            .fontRed {
                color: #D41D16;
                font-size: 30px;
                font-weight: bold;
            }

            &:first-of-type {
                width: 60%;
            }
        }

        .reward-data-column {

            >div {
                font-size: 36px;
                padding-top: 10px;
            }

            .fontRed {
                color: #D41D16;
                font-size: 42px;
                font-weight: bold;
            }

            img {
                height: 150px;
                vertical-align: sub;
                padding-left: 75px;
            }
        }


    }

    .compare {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0;

        .less {
            width: 40px;
            height: 40px;
        }

        .compare-data {
            width: 45%;

            p {
                margin-bottom: 10px;
            }

            p:first-child {
                font-size: 36px;
            }

            p:nth-child(2) {
                font-size: 24px;
            }

            p:last-child {
                font-size: 46px;
                font-weight: 500;
            }
        }
    }

    .update-time {
        font-size: 24px;
        color: #999999;
    }

    .fs-32 {
        font-size: 32px;
    }

    .blue {
        color: #007AFF;
        font-weight: 500;
    }

    .ranking-box {
        overflow: hidden;
        background-color: #fff;
        border-radius: 40px 40px 0 0;
    }

    .ranking-box-hd {
        display: flex;

        >div {
            // width: 50%;
            line-height: 100px;
            // font-size: 36px;
            font-weight: 500;
            text-align: center;
            color: #999999;
            padding: 0 15px;
            // background-color: #F5F5F5;

            &.on {
                position: relative;
                color: #333333;

                &::before {
                    position: absolute;
                    content: '';
                    left: 50%;
                    bottom: 20px;
                    width: 40px;
                    height: 6px;
                    transform: translate(-50%);
                    background-color: #333333;
                    border-radius: 4px;
                }
            }
        }
    }

    .tabs-box {
        padding: 0 30px;
    }

    .job-tabs {
        display: flex;
        // justify-content: space-around;
        align-items: center;
        border-radius: 30PX;
        margin: 30px 0;
    }

    .job-tab-item {
        color: #999999;
        font-size: 30px;
        padding: 10px 0;
        font-weight: 500;
        flex: 1;
        text-align: center;
        border-radius: 30PX;
        line-height: 40px;

        &.on {
            position: relative;
            color: #333333;

            &::before {
                position: absolute;
                content: '';
                left: 50%;
                bottom: 0px;
                width: 40px;
                height: 6px;
                transform: translate(-50%);
                background-color: #333333;
                border-radius: 4px;
            }
        }
    }

    .group-tabs {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        justify-content: space-between;
    }

    .group-tab-item {
        min-width: 22%;
        // margin-right: 30px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;
        padding: 3px 10px;

        &.on1 {
            color: #ffffff;
            background-color: #AF8BDF;
        }

        &.on2 {
            background-color: #D8BC92;
        }

        &.on3 {
            background-color: #DBC7C1;
        }
    }

    .ranking-list-box {
        border-top: 2px solid #eeeeee;
    }

    .ranking-list-item-box {
        padding: 0 20px;
    }

    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }
    }

    .ranking-num {
        width: 75px;
        margin-right: 25px;

        .color-red {
            color: #AB080B;
        }

        >div {
            width: 50px;
        }

        >img {
            width: 50px;
            height: 60px;
        }
    }

    .ranking-name {
        display: flex;
        align-items: center;
        // width: 220px;

        >.img {
            width: 60px;
            height: 60px;
            margin-right: 10px;
        }

    }

    .ranking-order {
        // width: 200px;
        text-align: center;
    }

    .ranking-bonus {
        // width: 240px;
        text-align: center;
    }



    .popup-rule {
        width: 650px;
        padding-bottom: 30px;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
    }

    .popup-rule-hd {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 120px;
        font-size: 36px;
        font-weight: 500;
        background-image: linear-gradient(#CEDBF0, #ffffff);
    }

    .popup-main {
        height: 600px;
        overflow-y: scroll;

        >.title {
            padding: 20px 40px;
            font-size: 28px;
            font-weight: 500;
        }

        >.describe {
            padding: 0 60px;
            font-style: 24px;
            color: #66757F;
            line-height: 46px;
        }
    }

    .popup-close {
        position: absolute;
        left: 50%;
        bottom: -90px;
        transform: translate(-50%);
    }

    .bg-color {
        height: 90px;
        margin: -30px 0;
    }

    .cityWrapper {
        padding: 20px 0;

        .cityBox {
            display: flex;
            align-items: center;

            .position {
                width: 23px;
                height: 28px;
                margin-left: 20px;
            }

            .arrow {
                width: 10px;
                height: 18px;
            }

            >span {
                padding: 0 15px;
            }
        }
    }

    .lineBorder {
        border-bottom: 1px solid #C9C9C9;
        padding-bottom: 30px;
    }

    .bonus-text {
        color: #D41D16;
        font-weight: bold;
    }

    .blue {
        color: #0072FF;
    }

    .red {
        color: #D62C18;
    }

    .width100 {
        width: 100px;
    }

    .width160 {
        width: 160px;
    }

    .width180 {
        width: 180px;
    }

    .width200 {
        width: 200px;
    }

    .width220 {
        width: 220px;
    }

    .width240 {
        width: 240px;
    }

    .width320 {
        width: 320px;
    }
</style>
<style lang="less">
    .ranking {
        .red {
            color: #D41D16;
            font-weight: 500;
        }

        .van-popup {
            overflow-y: visible;
        }

        .van-image__error {
            background-color: #A1A1A1;
        }

        .van-list__finished-text,
        .van-list__loading,
        .van-list__error-text {
            margin-top: -2px;
            background-color: #fff;
        }
    }
</style>
